import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    reconcileDate: Yup.string()
        .required('Required'),
    reconcileBalance: Yup.string()
        .required('Required'),
});

export default validationSchema;